/*jshint esversion: 6 */

$(function () {
    // $("#btnPromoClose").click(function (e) {
    //     e.preventDefault();

    //     $.ajax({
    //         url: $(this).attr("href"),
    //         success: function (data) {
    //             console.log("success");
    //             HidePromo();
    //         },
    //         error: function (fail) {
    //             console.log("error");
    //             HidePromo();
    //         }
    //     });
    // });
});

// function HidePromo() {
//     var divpromo = $("#div-promo-display, .promo-placeholder");

//     if (divpromo.length) {
//         divpromo.hide();
//     }
// }
